<template>
    <v-template>
        <v-container>
            <br>
            <v-layout justify-center row wrap>
                <h2 class="font-weight-light">เลือกกิจกรรมเพื่อตรวจสอบรายชื่อ</h2>
            </v-layout>
            <br>
            <v-layout md2 xs12 justify-center v-for="event in data" v-bind:key="event">
                <v-btn color="#97c763" block dark
                @click="routeToEvent(event.key)">
                <span style="white-space: normal;">{{event.name}}</span>
                </v-btn>
            </v-layout>
        </v-container>
    </v-template>
</template>

<script>
import firebase from 'firebase'

export default {
    data () {
        return {
            data: []
        }
    },
    mounted () {
        this.getAllData()
    },
    methods: {
        getAllData() {
            const db = firebase.database().ref('/all').once('value', (data) => {
                data.forEach(e => {
                    console.log(e.key)
                    let temp = {
                        key: e.key,
                        name: e.child("text").val().name
                    }
                    this.data.push(temp)
                })
            })
            console.log(this.data)
        },
        routeToEvent(key) {
            console.log(key)
            this.$router.push(`/search/`+ key)
        },
    }

}
</script>

<style>
.my-button {
    width: 100%;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;  
}

</style>
